// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1438":"339a0699","2412":"339a0699","5977":"905bdbac","6346":"b72a8383","9214":"357ac11c"}[chunkId] + ".chunk.css";
};